<template>
  <div
    class="visual absolute-visuals"
    :class="{ 'side-visual': !fullSize, 'full-size-visual': fullSize }"
  >
    <div class="absolute-visual-wrapper">
      <img
        class="absolute-sizer"
        src="../../assets/sessions/invisible-square.png"
        alt="transparent square"
      />
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{ fullSize?: boolean }>();
const fullSize = computed(() => props?.fullSize ?? false);
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.absolute-visuals.side-visual {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .absolute-visual-wrapper {
    position: relative;
    width: 100%;
    max-width: 100vh;
    // background-color: rgba(255, 255, 255, 0.2);
    // border: 1px solid red;

    img.absolute-sizer {
      display: inline;
      position: static;
      width: 100%;
    }

    & > * {
      position: absolute;
    }
  }
}

.absolute-visuals.full-size-visual {
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  padding: 0;

  .absolute-visual-wrapper {
    position: relative;
    width: 100%;
    height: 100%;

    img.absolute-sizer {
      display: none;
    }

    & > * {
      position: absolute;
    }
  }
}

.session.session-inline .absolute-visuals.side-visual {
  align-items: center;

  .absolute-visual-wrapper {
    max-width: 75vh;
  }
}

.absolute-visuals.visual.absolutely-positioned {
  position: absolute; // Rather than fixed, which is the standard for .visual
}
</style>
